import { COMPANY_SWITCHER_WIDTH, DRAWER_WIDTH } from 'src/constants/uiConsts';
import { useCompanySwitcherVisibility } from 'src/features/companies/useCompanySwitcherVisibility';

export const useDrawerWidth = (): number => {
  const isSidebarCompanySwitcherVisible = useCompanySwitcherVisibility();
  return isSidebarCompanySwitcherVisible.visibility === 'desktop'
    ? DRAWER_WIDTH + COMPANY_SWITCHER_WIDTH
    : DRAWER_WIDTH;
};
